export default "__VITE_ASSET__A202Kdn$__"